module.exports = __webpack_public_path__ + "img/spwk.714e7f11.png";